import { motion, AnimatePresence } from 'framer-motion';
import type { CardInstance, CardDefinition, Faction } from '../../types/kotch';
import { FACTION_INFO } from '../../data/kotch/factionDecks';
import Card from './Card';

interface CardHandProps {
  cards: CardInstance[];
  selectedCardId: string | null;
  onCardSelect: (cardInstanceId: string | null) => void;
  disabled?: boolean;
  playerFaction?: Faction | null;
  revealedCards?: string[];
  onCardHover?: (def: CardDefinition | null) => void;
}

export default function CardHand({
  cards,
  selectedCardId,
  onCardSelect,
  disabled = false,
  playerFaction,
  revealedCards = [],
  onCardHover,
}: CardHandProps) {
  const factionInfo = playerFaction ? FACTION_INFO[playerFaction] : null;

  if (cards.length === 0) {
    return (
      <div
        className={`kotch-hand ${factionInfo ? 'faction-accented' : ''}`}
        style={factionInfo ? { '--faction-color': factionInfo.themeColor } as React.CSSProperties : undefined}
      >
        <div className="kotch-hand-empty">No cards remaining</div>
      </div>
    );
  }

  return (
    <div
      className={`kotch-hand ${factionInfo ? 'faction-accented' : ''}`}
      style={factionInfo ? { '--faction-color': factionInfo.themeColor } as React.CSSProperties : undefined}
    >
      <AnimatePresence mode="popLayout">
        {cards.map((card, index) => (
          <motion.div
            key={card.instanceId}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8 }}
            transition={{ delay: index * 0.05 }}
          >
            <Card
              card={card}
              faceUp={true}
              selected={selectedCardId === card.instanceId}
              disabled={disabled}
              seenByOpponent={revealedCards.includes(card.instanceId)}
              playerFaction={playerFaction}
              onHover={onCardHover}
              onClick={() => {
                if (selectedCardId === card.instanceId) {
                  onCardSelect(null);
                } else {
                  onCardSelect(card.instanceId);
                }
              }}
            />
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
